<template>
    <section class="bg-orange-200">
        <div class="container pt-40 pb-20 mx-auto sm:w-full md:w-3/4 lg:w-2/4">
            <div class="mt-2 ml-10 mr-10">
                <div class="justify-center sm:w-full md:w-full lg:w-full">
                    <h1 class="mb-2 text-xl font-semibold text-center text-gray-800 dark:text-gray-100">
                        CUCI OpenData - สะสางดอกเบี้ย
                    </h1>
                </div>
            </div>
            <div class="mt-2 ml-10 mr-10 rounded-lg bg-gray-50 dark:bg-gray-900">
                <div  class="max-w-4xl pt-5 pl-5 pr-5">
                    <button class="px-2 py-1 font-bold text-white bg-blue-500 rounded hover:bg-blue-700 btn-sm">
                        รายปี
                    </button>
                    <button class="px-2 py-1 ml-1 font-bold text-white bg-blue-500 rounded hover:bg-blue-700 btn-sm">
                        รายเดือน
                    </button>
                </div>
                <div class="justify-center sm:w-full md:w-full lg:w-full">
                    <apexchart 
                        type="bar" 
                        height="350" 
                        width="100%" 
                        :options="barChartOptions" 
                        :series="barChartSeries">
                    </apexchart>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data(){
            return{
                barChartOptions: {
                    chart: {
                        type: 'bar',
                        events: {
                            click: function(chart, w, e) {
                                console.log(chart, w, e)
                            }
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '95%',
                            endingShape: 'rounded',
                            labels:{
                                position: 'top',
                            }
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        categories: [2562, 2663, 2564, 2565, 2566, 2567, 2568],
                    },
                    yaxis: {
                        title: {
                            text: 'บาท'
                        },
                        //formatter label 1000 to 1,000
                        labels: {
                            formatter: function (val) {
                                return val.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                        }
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    tooltip: {
                        theme: 'dark',
                        style: {
                            fontSize: '16px',
                            fontFamily: 'Helvetica, Arial, sans-serif'
                        },
                        x: {
                            show: true,
                            formatter: function (val) {
                                return `ปี ${val}`
                            }
                        },
                        y: {
                            formatter: function (val) {
                                return val.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " บาท"
                            },
                            title: {
                                formatter: () => {
                                    return `จำนวนเงิน : `;
                                }
                            }
                        }
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: '100%'
                            },
                            legend: {
                                position: 'bottom',
                                //set align legend to center
                                horizontalAlign: 'center',
                            },

                        },
                    }],
                    subtitle: {
                        text: 'ยอดสะสางดอกเบี้ยสะสมรายปี',
                        align: 'center',
                        margin: 10,
                        offsetX: 15,
                        offsetY: 5,
                        floating: false,
                        style: {
                            fontSize:  '16px',
                            fontWeight:  'bold',
                            fontFamily:  'Helvetica, Arial, sans-serif',
                            color:  '#9699a2'
                        },
                    }
                },
                barChartSeries: [{
                    data: [51972.19, 739217.2, 1027847.21, 307427.69, 1080165.97, 1232384.52, 207427.69]
                }]
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>